export default "__VITE_ASSET__DQPy_y9Z__"